// import { Location, PlatformLocation } from '@angular/common';
// import { Inject, Injectable } from '@angular/core';
// import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// import { BroadcastService, MsalAngularConfiguration, MsalService, MSAL_CONFIG, MSAL_CONFIG_ANGULAR } from '@azure/msal-angular';
// import { StoreUsersService } from '@services/cleanfill-core/store-users/store-users.service';
// import { ConfirmDialogResult, ConfirmDialogType } from '@widgets/site-common/confirm-dialog/confirm-dialog.model';
// import { ConfirmDialogService } from '@widgets/site-common/confirm-dialog/confirm-dialog.service';
// import { AuthError, Configuration, InteractionRequiredAuthError, UrlUtils, WindowUtils } from 'msal';
// import { environment } from 'src/environments/environment';
// import { AuthService } from '@services/core/auth.service';
// import { LegalEntityStatus } from '@services/cleanfill-api/cleanfill-api.generated';

// /*
//  * Original Source: https://github.com/AzureAD/microsoft-authentication-library-
// for-js/blob/dev/lib/msal-angular/src/msal-guard.service.ts
//  */

// @Injectable()
// export class RegistrationGuard implements CanActivate {
//   action: string;
//   redirectUri: string;
//   constructor(
//     @Inject(MSAL_CONFIG) private msalConfig: Configuration,
//     @Inject(MSAL_CONFIG_ANGULAR) private msalAngularConfig: MsalAngularConfiguration,
//     private msalService: MsalService,
//     private router: Router,
//     private activatedRoute: ActivatedRoute,
//     private location: Location,
//     private platformLocation: PlatformLocation,
//     private broadcastService: BroadcastService,
//     private dialogService: ConfirmDialogService,
//     private userService: StoreUsersService,
//     private authService: AuthService
//   ) {}

//   /**
//    * Builds the absolute url for the destination page
//    * @param path Relative path of requested page
//    * @returns Full destination url
//    */
//   getDestinationUrl(path: string): string {
//     // Absolute base url for the application (default to origin if base element not present)
//     const baseElements = document.getElementsByTagName('base');
//     const baseUrl = this.location.normalize(baseElements.length ? baseElements[0].href : window.location.origin);

//     // Path of page (including hash, if using hash routing)
//     const pathUrl = this.location.prepareExternalUrl(path);

//     // Hash location strategy
//     if (pathUrl.startsWith('#')) {
//       return `${baseUrl}/${pathUrl}`;
//     }

//     // If using path location strategy, pathUrl will include the relative portion of the base path (e.g. /base/page).
//     // Since baseUrl also includes /base, can just concatentate baseUrl + path
//     return `${baseUrl}${path}`;
//   }

//   /**
//    * Interactively prompt the user to login
//    * @param url Path of the requested page
//    */
//   async loginInteractively(url: string) {
//     if (this.msalAngularConfig.popUp) {
//       return this.msalService
//         .loginPopup({
//           scopes: this.msalAngularConfig.consentScopes,
//           extraQueryParameters: this.msalAngularConfig.extraQueryParameters
//         })
//         .then(() => true)
//         .catch(() => false);
//     }

//     const redirectStartPage = this.getDestinationUrl(url);
//     const randomKey = url.indexOf('?') > 0 ? url.split(/\?|=/)[1] : '';
//     this.msalService.loginRedirect({
//       redirectStartPage: `${environment.msalRedirectUrl || window.location.origin}/${this.redirectUri}`,
//       redirectUri: `${environment.msalRedirectUrl || window.location.origin}/${this.redirectUri}`,
//       scopes: this.msalAngularConfig.consentScopes,
//       extraQueryParameters: this.msalAngularConfig.extraQueryParameters,
//       state: `${this.action}:${randomKey}`
//     });
//   }

//   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
//     this.action = route.data.action;
//     this.redirectUri = route.data.redirectUri;
//     if (this.authService.activeUser !== null) {
//       if (this.authService.activeUser.legalEntityStatus === LegalEntityStatus.Active) {
//         this.dialogService
//           .confirm(
//             `You are already registered with an active company.
//         You will now be logged out from this company and can restart the registration process.`,
//             '',
//             ConfirmDialogType.Ok
//           )
//           .then(result => {
//             if (result === ConfirmDialogResult.Ok) {
//               this.msalService.logout();
//               // this.router.navigate(['/']);
//               return;
//             }
//           });
//       }
//     }

//     this.msalService.getLogger().verbose('location change event from old url to new url');

//     // If a page with MSAL Guard is set as the redirect for acquireTokenSilent,
//     // short-circuit to prevent redirecting or popups.
//     if (UrlUtils.urlContainsHash(window.location.hash) && WindowUtils.isInIframe()) {
//       this.msalService
//         .getLogger()
//         .warning(
//           'redirectUri set to page with MSAL Guard. It is recommended to not set redirectUri to a page that requires authentication.'
//         );
//       return false;
//     }

//     if (!this.msalService.getAccount()) {
//       return this.loginInteractively(state.url);
//     }

//     return this.msalService
//       .acquireTokenSilent({
//         scopes: [this.msalConfig.auth.clientId]
//       })
//       .then(() => true)
//       .catch((error: AuthError) => {
//         if (InteractionRequiredAuthError.isInteractionRequiredError(error.errorCode)) {
//           this.msalService.getLogger().info(`Interaction required error in MSAL Guard, prompting for interaction.`);
//           return this.loginInteractively(state.url);
//         }

//         this.msalService.getLogger().error(`Non-interaction error in MSAL Guard: ${error.errorMessage}`);
//         throw error;
//       });
//   }
// }
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { LegalEntityStatus, LegalEntityType, UsersClient } from '@services/cleanfill-api/cleanfill-api.generated';
import { AuthService } from '@services/core/auth.service';
import { ConfirmDialogResult, ConfirmDialogType } from '@widgets/site-common/confirm-dialog/confirm-dialog.model';
import { ConfirmDialogService } from '@widgets/site-common/confirm-dialog/confirm-dialog.service';
import { Observable } from 'rxjs';

@Injectable()
export class RegistrationGuard implements CanActivate {
  constructor(
    private msalService: MsalService,
    public auth: AuthService,
    public router: Router,
    private userClient: UsersClient,
    private dialogService: ConfirmDialogService
  ) { }
  canActivate(): Observable<boolean> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth?.activeUser && !this.auth?.activeUser?.isTermAccepted && !this.auth?.activeUser?.legalEntityUniqueId) {
      return this.router.parseUrl('/register/terms');
    }
    if (this.auth?.activeUser && !this.auth?.activeUser?.isApproved) {
      this.msalService.logout();
      // this.router.navigate(['/']);
      return;
    }
    if (!this.auth?.activeUser) {
      return this.userClient
        .createUser(undefined)
        .toPromise()
        .then(x => {
          this.auth.loadActiveUser(x);
          return true;
        });
    }
    if (this.auth?.activeUser?.uniqueId && this.auth?.activeUser?.legalEntityUniqueId) {
      if (this.auth.activeUser.legalEntityStatus === LegalEntityStatus.Active) {
        this.dialogService
          .confirm(
            `You are already registered with an active company.
        You will now be logged out from this company and can restart the registration process.`,
            '',
            ConfirmDialogType.Ok
          )
          .then(result => {
            if (result === ConfirmDialogResult.Ok) {
              this.msalService.logout();
              // this.router.navigate(['/']);
              return;
            }
          });
      } else {
        return this.auth.loadPermissions().then(t => {
          const legalEntityUniqueId = this.auth.activeUser.legalEntityUniqueId;
          if (legalEntityUniqueId) {
            if (this.auth?.activeUser?.legalEntityType === LegalEntityType.QualifiedPerson) {
              return this.router.parseUrl(`/register/qp/${legalEntityUniqueId}`);
            } else {
              return this.router.parseUrl(`/register/company/${legalEntityUniqueId}`);
            }
          } else {
            if (this.auth?.activeUser?.legalEntityType === LegalEntityType.QualifiedPerson) {
              return this.router.parseUrl(`/register/choose/qp/new`);
            } else {
              return this.router.parseUrl(`/register/choose/company/new`);
            }
          }
        });
      }
    }
    return true;
  }
}
